import { useSelector } from 'react-redux'
import { AppState } from '../redux/store'
import { useMemo } from 'react'
import { calculateUPCCategories } from '../utils/compareProductFilter'

export const useCompareSkuCategories = () => {
	const compareClusters = useSelector(
		(state: AppState) => state.cluster.compare,
	)

	return useMemo(
		() => calculateUPCCategories(compareClusters),
		[compareClusters],
	)
}
